import {type EquipmentData} from '../types'

export const getEquipmentLabel = (equipment: EquipmentData, withoutId?: boolean) => {
  if (withoutId) {
    return equipment.text ?? ''
  }

  const id = getEquipmentIdLabel(equipment)

  return equipment.text ? `${id} - ${equipment.text}` : id
}

export const getEquipmentIdLabel = (equipment: EquipmentData) => {
  // remove the leading zeros from the SAP number
  if (equipment.idType === 'sapNumber') {
    return equipment.id.replace(/^0+/, '')
  }
  return equipment.id
}
